import { listGeofencesQuery } from './queries';
import { getBatchedQueryData } from '../utils';

const listGeofences = async ({ type, ids, filterDeleted = true, filterParams }) => {
    try {
        const data = await getBatchedQueryData(listGeofencesQuery, { type, ids, filterDeleted, filterParams }, 'ids');
        return data;
    } catch (error) {
        return { error };
    }
};

export default listGeofences;
